import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import queryString from 'query-string';

import {
  NOTIFY_YOUR_CUSTOMER,
  getCampaignStepBarNameWithType,
} from 'components/base/prompt/NextStepConfig';
import NextStepPrompt from 'components/base/prompt/NextStepPrompt';
import {
  URLFilterKeys,
  URLFragments,
} from 'components/campaign/CampaignUrlConfig';
import { ActionType, CampaignType } from 'config/CustomEnums';
import { PermissionCodes } from 'config/PermissionCodes';
import { MESSAGE_TAB } from 'containers/engagement/message/MessageList';

import './PublishCampaignPrompt.scss';
import { tierTypeConfig } from 'config/TierTypeConfig';

function PublishCampaignPrompt(props) {
  const defaultShow = props.show || false;
  const path = props.path || '/campaigns';
  const actionType = props.actionType;
  const history = useHistory();
  const [show, setShow] = useState(false);

  if (!show && defaultShow) {
    setShow(true);
  }

  const getTitle = () => {
    switch (actionType) {
      case ActionType.save:
        return 'Successfully Saved!';
      case ActionType.update:
      case ActionType.tempForPulished:
        return 'Successfully Updated!';
      case ActionType.submitForApproval:
        return 'Successfully Submitted!';
      case ActionType.forcePublish:
      case ActionType.approval:
        return 'Successfully Approved!';
      case ActionType.withdraw:
        return 'Successfully Withdrawn!';
      default:
        return 'Successfully Unpublished!';
    }
  };

  const getDescription = () => {
    switch (actionType) {
      case ActionType.save:
        return `You can update the content.`;
      case ActionType.update:
      case ActionType.tempForPulished:
        return `The campaign is successfully updated.`;
      case ActionType.submitForApproval:
        return `Notify the checkers to approve the content.`;
      case ActionType.forcePublish:
      case ActionType.approval:
        return tierTypeConfig.messages ? `Let your customers know about the campaign.` : "";
      case ActionType.withdraw:
        return `You can update the content.`;
      default:
        return `Campaign is successfully unpublished.You can publish again by edit the status.`;
    }
  };

  const getSteps = () => {
    if (
      actionType === ActionType.approval ||
      actionType === ActionType.forcePublish
    ) {
      if (!tierTypeConfig.messages) {
        return null;
      };
      const currentStep = getCampaignStepBarNameWithType(props.campaignType);
      return {
        stepNames: [currentStep, NOTIFY_YOUR_CUSTOMER],
        current: currentStep,
      };
    }
    return null;
  };

  const getButtons = () => {
    const buttons = [
      {
        text: 'Back to list',
        action: () => {
          let hash = URLFragments.list;
          if (props.campaignType === CampaignType.generalMessageCampaign)  {
            hash = MESSAGE_TAB.MESSAGE_CAMPAIGN
          } else if (props.campaignType === CampaignType.ticketCampaign) {
            hash = URLFragments.eventList
          }
          const search = queryString.stringify({
            [URLFilterKeys.page]: 1,
            [URLFilterKeys.searchKey]: '',
            [URLFilterKeys.rank]: true,
          });
          history.push({
            pathname: path,
            hash,
            search: search,
          });
        },
        requires: PermissionCodes.changeCampaign,
      },
    ];
    if (
      tierTypeConfig.messages && (
        actionType === ActionType.approval ||
        actionType === ActionType.forcePublish
      )
    ) {
      buttons.unshift({
        text: 'Create message',
        action: () => {
          history.push({
            pathname: '/messages/create',
            search: `campaign=${props.campaignId}`,
          });
        },
        requires: PermissionCodes.addMessage,
      });
    }
    return buttons;
  };

  return (
    <NextStepPrompt
      show={show}
      title={getTitle()}
      description={getDescription()}
      steps={getSteps()}
      buttons={getButtons()}
    />
  );
}

export default PublishCampaignPrompt;
